import { TRootState } from 'store/types'
import { createSelector } from '@reduxjs/toolkit'
import { IUserAudio } from 'store/types/audio'

const selector = (state: TRootState) => state.audio

const soundsGenres = createSelector(selector, state => state.soundsGenres)

const soundsGenresWithoutSounds = createSelector(soundsGenres, soundsGenres =>
  soundsGenres.map(genre => {
    return { ...genre, sounds: undefined }
  })
)

const genresDuration = createSelector(soundsGenres, soundsGenres => {
  return soundsGenres.length ? soundsGenres[0].sounds[0].duration : null
})

const userSounds = createSelector(selector, state =>
  state.userSounds.filter(sound => !sound.voiceOver)
)

const libSoundsInOneList = createSelector(soundsGenres, soundsGenres =>
  soundsGenres.reduce(
    (acc, genre) => {
      return [...acc, ...genre.sounds]
    },
    <IUserAudio[]>[]
  )
)

const usedLibSounds = createSelector(selector, state => state.usedLibSounds)

const usedLibSoundsMapTable = createSelector(usedLibSounds, usedLibSounds => {
  return usedLibSounds.reduce(
    (acc, sound) => {
      const key = sound[0].title
      acc[key] = sound
      return acc
    },
    <Record<string, IUserAudio[]>>{}
  )
})

export const audioSelectors = {
  soundsGenres,
  soundsGenresWithoutSounds,
  genresDuration,
  userSounds,
  libSoundsInOneList,
  usedLibSoundsMapTable
}
